<app-loader></app-loader>

<div class="layout-container" [ngClass]="containerClass">
   <app-sidebar></app-sidebar>
   <app-topbar style="background-color: rgb(45, 62, 80)"></app-topbar>
   <div class="layout-content-wrapper" style="border-top-left-radius: 2rem; background: #f5f9ff; padding-top: 2rem;">
      <app-breadcrumb class="content-breadcrumb"></app-breadcrumb>
      <div class="layout-content" style="padding-left: 2rem; padding-right: 2rem; border-radius: 2rem">
         <app-breadcrumb class="topbar-breadcrumb"></app-breadcrumb>
         <router-outlet></router-outlet>
      </div>
   </div>
   <app-profilemenu></app-profilemenu>
   <p-scrollTop [threshold]="500"></p-scrollTop>
   <elevenlabs-convai
      #elevenLabsWidget
      *ngIf="isSuperAdmin"
      id="elevenlabs-widget"
      class="elevenlabs-widget"
      [class.elevenlabs-widget--hidden]="!(elevenLabsWidgetService.visible$ | async)"
      agent-id="agent_0201kqxxammqfrqa9x9vbsxk95cm"
      variant="expanded"
      default-expanded="true"
      always-expanded="true"
      dismissible="false"
   ></elevenlabs-convai>
</div>
